import React, { useState } from "react";

import DstAlert from "../../../../components/DstAlert/DstAlert";
import DstButton from "../../../../components/DstButton/DstButton";
import MultiSelectLiveDropdown from "../../../../components/MultiSelectLiveDropdown/MultiSelectLiveDropdown";
import Popup from "../../../../components/Popup/Popup";
import { formatDatetimeLocalValue, isPast } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { EvaluationInvitationModalProps } from "./InvitationModal.d";
import { inviteUsersToEvaluation } from "./InvitationModal.function";

const EvaluationInvitationModal = ({ closeModal, language, show, evaluationId }: EvaluationInvitationModalProps) => {
  const [usersToInvite, setUsersToInvite] = useState<number[]>([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertProps, setAlertProps] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [scheduledDate, setScheduledDate] = useState<string>("");

  const _displayAlert = (props: any) => {
    setAlertProps(props);
    setShowAlert(true);
    setLoading(false);
    closeModal();
  };

  const _handleConfirm = () => {
    setLoading(true);
    inviteUsersToEvaluation(usersToInvite, language, evaluationId!, _displayAlert, scheduledDate);
    _resetSelection();
  };

  const _resetSelection = () => {
    setUsersToInvite([]);
    setScheduledDate("");
  };

  return (
    <React.Fragment>
      <Popup show={show} onClose={() => closeModal()} modalTitle={translate(language, "PAGES.EVALUATION.MODAL.TITLE")}>
        <MultiSelectLiveDropdown
          category={["users"]}
          label={
            usersToInvite && usersToInvite.length > 0
              ? `${usersToInvite.length} ${translate(language, "PAGES.EVALUATION.MODAL.INVITATION.SELECTED_USERS")}`
              : translate(language, "PAGES.EVALUATION.MODAL.INVITATION.SELECT_USERS")
          }
          language={language}
          mockClass="rounded-0 rounded-end"
          toggleClass="w-100 border"
          initialSelectedItems={usersToInvite.map((user: number) => ({
            category: "users",
            value: {
              id: user,
            },
          }))}
          onConfirm={(selectedUsers: any[]) => setUsersToInvite(selectedUsers.map((user) => user.value.id))}
        />
        <div className="mt-3 m-regular">
          <label htmlFor="scheduledDate">
            {translate(language, "PAGES.EVALUATION.MODAL.INVITATION.SCHEDULE_DATE_LABEL")}
          </label>
          <input
            type="datetime-local"
            id="scheduledDate"
            className="form-control"
            value={scheduledDate}
            onChange={(event) => setScheduledDate(event.target.value)}
            min={formatDatetimeLocalValue()}
          />
        </div>
        <div className="d-flex justify-content-end mt-4 gap-2">
          <DstButton
            variant="secondary"
            value={translate(language, "GLOBAL.CANCEL")}
            clickFunction={() => {
              closeModal();
              _resetSelection();
            }}
            disabled={usersToInvite.length === 0}
          />

          <DstButton
            btnWidth="100px"
            variant="primary"
            value={translate(language, "GLOBAL.CONFIRM")}
            clickFunction={_handleConfirm}
            disabled={usersToInvite.length === 0 || (!!scheduledDate && isPast(scheduledDate))}
            loading={loading}
          />
        </div>
      </Popup>

      <DstAlert show={showAlert} onHide={() => setShowAlert(false)} {...alertProps} />
    </React.Fragment>
  );
};

export default EvaluationInvitationModal;
